<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace, isNumber } from '@bd/vue3-utils'
import { Empty } from '../Common/Empty'
import { Table, type TableColumnType } from 'ant-design-vue'
import { GENDER_LABEL } from '@/constant/biz'
import { Tag } from '../Common/Tag'

const [name] = createNamespace('JtZchSocialSecurityList')

/** 创建读取 security 字段的列配置 */
const createSecurityColumn = (title: string, field: string, width: number): TableColumnType => ({
  title,
  dataIndex: `ss_${field}`,
  width,
  customRender: ({ record }) => record?.security?.[field]
})

export default defineComponent({
  name,
  props: {
    list: {
      type: Array as PropType<ApiFamilyMembers.Item[]>,
      default: () => []
    }
  },
  setup(props) {
    const columns: TableColumnType[] = [
      { title: '姓名', dataIndex: 'userName', width: 150 },
      {
        title: '购买情况',
        dataIndex: 'isBuying',
        width: 100,
        customRender: ({ text }) => {
          if (!isNumber(text)) return <Tag color='#bbb'>未知</Tag>
          return <Tag color={text ? 'green' : 'red'}>{text ? '已购买' : '未购买'}</Tag>
        }
      },
      createSecurityColumn('身份证号码', 'idCard', 200),
      {
        title: '性别',
        dataIndex: 'ssGender',
        width: 100,
        customRender: ({ record }) => {
          const gender = record?.security?.gender
          return isNumber(gender) ? GENDER_LABEL[gender] : undefined
        }
      },
      createSecurityColumn('村组', 'village', 150),
      createSecurityColumn('合村并组前村民小组', 'oldVillage', 200),
      createSecurityColumn('户籍所在地', 'idCardAddress', 200),
      createSecurityColumn('征地时间', 'landTime', 150),
      createSecurityColumn('与户主关系', 'relation', 150)
    ]

    return () => (props.list.length === 0 ? <Empty /> : <Table dataSource={props.list} pagination={false} columns={columns} size='middle' />)
  }
})
</script>
